<!--
    描述：电子保函 -> 标段状态更新
    时间：2023-02-07
    Created by zcc
-->
<template>
	<div class="bh-main operation-layout" :class="{ pd0: !routeQuery }">
		<!-- 列表查询页 -->
		<filter-layout @search="doSearch" @reset="doReset" v-if="!routeQuery" hasMore>
			<template #filter>
				<el-form class="flex-row-form colspan-4" size="small" ref="searchRef" :model="searchForm" label-width="130px">
					<el-form-item label="标段名称" prop="bidName">
						<el-input :placeholder="'请输入'" clearable v-model="searchForm.bidName"> </el-input>
					</el-form-item>
					<el-form-item label="标段编号" prop="bidNo">
						<el-input :placeholder="'请输入'" clearable v-model="searchForm.bidNo"> </el-input>
					</el-form-item>
					<el-form-item label="项目标段唯一标识" prop="projectBidUniqueNo">
						<el-input :placeholder="'请输入'" clearable v-model="searchForm.projectBidUniqueNo"> </el-input>
					</el-form-item>
					<el-form-item label="更新是否成功" prop="updateFlag">
						<el-select v-model="searchForm.updateFlag" :placeholder="'请选择'" clearable>
							<el-option v-for="(item, index) in updateFlagList" :key="index" :value="item.value" :label="item.label"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</template>
			<template #more>
				<el-form class="flex-row-form colspan-4" size="small" ref="searchRef" :model="searchForm" label-width="130px">
					<el-form-item label="更新时间" prop="dateArr" class="date-time">
						<el-date-picker
							v-model="searchForm.dateArr"
							type="daterange"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							value-format="yyyy-MM-dd"
						></el-date-picker>
					</el-form-item>
				</el-form>
			</template>
			<template #content>
				<!-- 非请求参数 正常查看 -->
				<div class="operation-main">
					<div class="operation-header">
						<div class="title">
							合计更新记录：<span class="blue">{{ tableObj.total }}</span> 个
						</div>
						<div class="btnGroups"></div>
					</div>
					<div class="operation-container w-table-layout w-table-page">
						<div class="w-table-content" v-show="tableShow">
							<el-table ref="xTable" :data="tableObj.data" highlight-current-row height="100%" size="mini" border>
								<el-table-column type="index" label="" width="50" align="center"> </el-table-column>
								<el-table-column prop="id" label="业务流水号" align="center" width="180" show-overflow-tooltip> </el-table-column>
								<el-table-column prop="bidName" label="标段名称" align="center" width="200" show-overflow-tooltip></el-table-column>
								<el-table-column prop="bidNo" label="标段编号" align="center" width="149" show-overflow-tooltip></el-table-column>
								<el-table-column
									prop="projectBidUniqueNo"
									label="项目标段唯一标识"
									align="center"
									width="200"
									show-overflow-tooltip
								></el-table-column>
								<el-table-column
									prop="bidOpeningDate"
									label="开标时间"
									width="180"
									align="center"
									show-overflow-tooltip
								></el-table-column>
								<el-table-column prop="reason" label="瀚华当前标段状态" width="160" align="center" show-overflow-tooltip>
									<template slot-scope="scope">
										<span v-if="scope.row.reason == '1'">撤标</span>
										<span v-else-if="scope.row.reason == '2'">流标</span>
										<span v-else-if="scope.row.reason == '3'">延标</span>
										<span v-else-if="scope.row.reason == '4'">中标</span>
										<span v-else>其它</span>
									</template>
								</el-table-column>
								<el-table-column
									prop="updateTime"
									label="状态更新时间"
									width="180"
									align="center"
									show-overflow-tooltip
								></el-table-column>
								<el-table-column prop="sysSourceName" label="业务来源" width="100" align="center" show-overflow-tooltip>
								</el-table-column>
								<el-table-column prop="updateFlag" label="更新是否成功" width="180" align="center" show-overflow-tooltip>
									<template slot-scope="scope">
										<span v-if="scope.row.updateFlag == '0'" class="status-img">
											<img src="../../../../assets/images/fail.png" alt="" />
											失败
										</span>
										<span v-else class="status-img">
											<img src="../../../../assets/images/success.png" alt="" />
											成功
										</span>
									</template>
								</el-table-column>
								<el-table-column align="center" width="100">
									<template slot="header">操作</template>
									<!-- v-if="roleBtns.includes('memberDetail')" -->
									<template slot-scope="scope">
										<el-button type="primary" size="small" round plain class="table-btn" @click="showDetail(scope.row)">
											<svg-icon icon-class="form-details"></svg-icon>
											详情
										</el-button>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<div class="w-table-footer">
							<el-pagination
								@size-change="handleSizeChange"
								@current-change="handleCurrentChange"
								:current-page="tableObj.currentPage"
								:page-sizes="tableObj.pageList"
								:page-size="tableObj.pageSize"
								:total="tableObj.total"
								layout="total, sizes, prev, pager, next, jumper"
							>
							</el-pagination>
						</div>
					</div>
				</div>
			</template>
		</filter-layout>

		<!-- 详情页 -->
		<template v-else>
			<memberDetail ref="memberDetail"></memberDetail>
		</template>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import memberDetail from './components/detail'
import * as API from 'api/modules/bh/bh-lot-status-update'

export default {
	name: 'bh-lot-status-update-index',
	components: {
		memberDetail
	},
	data() {
		return {
			btnLoading: false,
			searchToggle: true,
			tableShow: true,
			//会员类型下拉信息
			accountTypeDL: [],
			//证件类型
			certTypeDL: [],
			searchForm: {
				bidNo: '', //标段编号
				bidName: '', //标段名称
				projectBidUniqueNo: '', //项目标段唯一标识
				updateFlag: '', //更新是否成功
				dateArr: [],
				updateTimeStart: null, //更新时间起
				updateTimeEnd: null //更新时间止
			},
			tableObj: {
				data: [],
				currentPage: 1, // 当前页码
				pageList: [10, 20, 50, 100], // 显示条数数组
				pageSize: 10, // 当前显示条数
				total: 0 // 当前总条数
			},
			updateFlagList: [
				{
					label: '全部',
					value: ''
				},
				{
					label: '失败',
					value: 0
				},
				{
					label: '成功',
					value: 1
				}
			]
		}
	},
	watch: {
		// 监听 筛选元素的 切换展示 重新调整表格高度
		searchToggle() {
			this.tableShow = false
			setTimeout(() => {
				this.tableShow = true
			}, 50)
			setTimeout(() => {
				this.$refs.xTable.doLayout()
			}, 1000)
		}
	},
	computed: {
		...mapState('app', { isBack: (state) => state.isBack }),
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns
		}),
		routeQuery() {
			return this.$route.query.type
		}
	},
	created() {
		// 如果是 返回的
		if (this.isBack) {
			if (this.$getSessionItem('params')) {
				let params = JSON.parse(this.$getSessionItem('params'))
				Object.keys(this.searchForm).forEach((key) => (this.searchForm[key] = params[key]))
				this.tableObj.currentPage = params.currentPage
				this.tableObj.pageSize = params.pageSize

				// 移除 避免污染
				this.$removeSessionItem('params')
			}
		}
		this.getSelectSectionList()
	},
	methods: {
		//查询
		doSearch() {
			this.getSelectSectionList()
		},
		//获取分页列表信息
		getSelectSectionList() {
			this.tableObj.data = []
			if (this.searchForm.dateArr && this.searchForm.dateArr.length > 0) {
				this.searchForm.updateTimeStart = this.searchForm.dateArr[0] + ' 00:00:00'
				this.searchForm.updateTimeEnd = this.searchForm.dateArr[1] + ' 23:59:59'
			} else {
				this.searchForm.updateTimeStart = ''
				this.searchForm.updateTimeEnd = ''
			}
			let param = Object.assign({}, this.searchForm)
			param.current = this.tableObj.currentPage
			param.size = this.tableObj.pageSize
			API.getSelectSectionList(param).then((res) => {
				if (res.operationCode == 1) {
					this.tableObj.data = res.data.records
					this.tableObj.total = parseInt(res.data.total)
				}
			})
		},
		//重置查询
		doReset() {
			Object.keys(this.searchForm).forEach((key) => (this.searchForm[key] = ''))
			this.searchForm.updateTimeStart = null
			this.searchForm.updateTimeEnd = null
			this.searchForm.dateArr = []
			this.tableObj.pageSize = 10
			this.tableObj.currentPage = 1
			this.getSelectSectionList()
		},
		//操作-详情
		showDetail(row) {
			let params = Object.assign({}, this.searchForm)
			params.currentPage = this.tableObj.currentPage
			params.pageSize = this.tableObj.pageSize
			this.$setSessionItem('params', JSON.stringify(params))
			this.$router.push({
				path: 'bh-lot-status-update-index',
				query: {
					type: 'memberDetail',
					id: row.id
				}
			})
		},
		//刷新
		reFresh() {
			Object.keys(this.searchForm).forEach((key) => (this.searchForm[key] = ''))
			this.tableObj.pageSize = 10
			this.tableObj.currentPage = 1
			this.getSelectSectionList()
		},
		// 切换显示条数
		handleSizeChange(val) {
			this.tableObj.pageSize = val
			this.getSelectSectionList()
		},
		//切换当前页码
		handleCurrentChange(val) {
			this.tableObj.currentPage = val
			this.getSelectSectionList()
		},
		// 是否展开搜索区域
		changeState() {
			this.searchToggle = !this.searchToggle
		},
		// 开始时间的 pickOption
		beginDate() {
			let that = this
			return {
				disabledDate(time) {
					let endTime = that.searchForm.updateTimeEnd
					if (endTime) {
						return time.getTime() >= new Date(endTime).getTime()
					} else return false
				}
			}
		},
		// 结束时间的 pickOption
		processDate() {
			let that = this
			return {
				disabledDate(time) {
					let startTime = that.searchForm.updateTimeStart
					if (startTime) {
						return time.getTime() <= new Date(startTime).getTime()
					} else return false
				}
			}
		},
		// 返回
		goBack() {
			this.$router.push({ path: '/bh-lot-status-update-index' })
		}
	}
}
</script>

<style lang="less" scoped>
.operation-layout.pd0 {
	padding: 0;
}
.bh-main {
	.filter-box {
		padding-top: 5px;
	}

	/deep/ .search-form {
		.el-col {
			height: 48px;
		}

		.text-center {
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}

	.blue-text {
		color: #2671cc;
		cursor: pointer;
	}

	.blue-text:hover {
		color: blue;
	}

	.el-switch.is-disabled {
		opacity: 1;
	}

	/deep/ .el-switch.is-disabled .el-switch__core,
	/deep/ .el-switch.is-disabled .el-switch__label {
		cursor: pointer !important;
	}
}
.w-table-content {
	/deep/ .el-radio__label {
		display: none;
	}
}
.label-tooltip {
	max-width: 600px;
	max-height: 140px;
	overflow-y: auto;
	overflow-x: hidden;
}

.primary-dialog {
	/deep/ .el-dialog__body {
		padding: 30px;
	}

	.row-label {
		height: 40px;
		line-height: 40px;
		padding-right: 15px;
	}

	.row-btn {
		padding-left: 10px;
		width: 100%;
	}

	.tags-container {
		line-height: 40px;
		max-height: 120px;
		overflow-y: auto;

		/deep/ .el-tag {
			cursor: pointer;
		}
	}

	.tags-all-container {
		line-height: 30px;
		max-height: 300px;
		overflow-y: auto;

		/deep/ .el-tag {
			cursor: pointer;
		}
	}
}

.status-img {
	display: flex;
	align-items: center;
	justify-content: center;

	img {
		margin-right: 5px;
	}
}
</style>
